import { waitForAuth } from '../auth/helpers';
import { all, getContext, takeLeading, call } from 'redux-saga/effects';
import { getIndicatorViewModels } from 'src/lib/dictionary/dictionary';
import type { SagaContext } from 'src/store/types';

export function* prefillIndicatorList() {
    try {
        yield* waitForAuth();
        const container: NonNullable<SagaContext['container']> = yield getContext('container');
        const queryClient = container.get('QueryClient');

        const fetchQuery = () =>
            queryClient.fetchQuery({
                queryKey: ['indicators'],
                queryFn: () => getIndicatorViewModels(),
            });

        yield call(fetchQuery);
    } catch (_e) {}
}

export function* queryClientSagas() {
    yield all([
        takeLeading(
            ['masq::access-token::set', 'masq::access-token::clear', 'superuser::set-expiration', 'access-token::set'],
            prefillIndicatorList,
        ),
    ]);
}
